import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_107: FaireProductEntity = {
  token: "catalog_prod_prod-107",
  type: "product",
  name: "Storage Container - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 64.99,
  msrpDollars: 162.48,
  sku: "CA0107",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_camp",
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: true,
  inStock: false,
  stockLevel: 64,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_womens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
